"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormEditStore from "Stores/Forms/FormEditStore";
import { destroyForm, formEditInitialize } from "Actions/Forms/FormEditActions";
import { topBarSetDynToolBarContent } from "Actions/TopBarActions";
import { Fields, System } from "Constants/objects";
import { Messages } from "Messages";
import ReactDOM from 'react-dom';
import FormEditTable from "Components/Forms/FormEditTable";
import { formSubmit, navigateToParent } from "Actions/Forms/FormActions";
import { createTableID, getAddSSFilter, getShowRowSSFilter, getSSTableCols, setAddFilter, setLSTableCols, setShowRowFilter } from "D5Utils/functions";

var styles = function styles(theme) {
  return {
    formHeight: {
      height: 'calc(100% - 64px)'
    },
    formButtonsPanel: {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingRight: '20px'
    },
    formEditButtons: {
      margin: theme.spacing.unit
    }
  };
};

var FormEdit =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormEdit, _React$Component);

  function FormEdit(props) {
    var _this;

    _classCallCheck(this, FormEdit);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormEdit).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "store", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {});

    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.copySSToLS = _this.copySSToLS.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(FormEdit, [{
    key: "_onChange",
    value: function _onChange() {
      var storeData = this.store.getList(this.props.UUID);
      this.setState(storeData);
    }
  }, {
    key: "_onCancelClick",
    value: function _onCancelClick() {
      navigateToParent(this.props.UUID);
    }
  }, {
    key: "_onSubmitClick",
    value: function _onSubmitClick() {
      formSubmit(this.props.UUID);
    }
  }, {
    key: "_onApplyClick",
    value: function _onApplyClick() {
      formSubmit(this.props.UUID, true);
    }
  }, {
    key: "initForm",
    value: function initForm() {
      var viewMode = this.props.formObj.viewMode;
      $(this.scrollView).dxScrollView({
        height: viewMode === System.VIEW_MODE.MODAL ? '100%' : 'calc(100% - 8px)',
        width: '100%',
        elementAttr: {
          id: "fscrl-".concat(this.props.UUID)
        },
        scrollByContent: true,
        scrollByThumb: true,
        showScrollbar: "always"
      });
      this.instanceForm = this.formEl;
      this.initOwner();
      var instances = {
        form: this.instanceForm,
        popup: this.popupInstance,
        scrollView: this.scrollView
      };
      formEditInitialize({
        formObj: this.props.formObj,
        instances: instances,
        formUUID: this.props.UUID,
        formID: this.props.formID,
        parentUUID: this.props.parentUUID,
        additionalData: this.props.additionalData,
        parentTitle: this.props.parentTitle,
        store: this.store,
        disablingButtons: this.disablingButtons.bind(this)
      });
    }
  }, {
    key: "initOwner",
    value: function initOwner() {
      var that = this;
      var _this$props$formObj = this.props.formObj,
          viewMode = _this$props$formObj.viewMode,
          title = _this$props$formObj.title,
          mode = _this$props$formObj.mode;
      var UUID = this.props.UUID;
      var caption = title || '';
      caption = mode === 'edit' ? caption : "".concat(caption, "<div style=\"font-size:15px;display:inline-block;position:relative;top:-4px;\">*</div>");
      this.buttonPanel = this.createButtonPanel();

      if (viewMode === System.VIEW_MODE.MODAL) {
        this.popupInstance = this.$popupEl.dxPopup({
          dragEnabled: true,
          showTitle: true,
          tabIndex: -1,
          closeOnOutsideClick: false,
          width: 'auto',
          height: 'auto',
          maxHeight: '98%',
          maxWidth: '75%',
          minHeight: '300px',
          minWidth: '500px',
          position: {
            my: 'center',
            at: 'center',
            of: 'body'
          },
          onShown: function onShown(e) {
            $("#fscrl-".concat(UUID)).find('.dx-scrollable-container').attr('tabIndex', -1);
          },
          contentTemplate: function contentTemplate(container) {
            container.append(that.scrollView);
            return container.append(that.scrollView);
          },
          // onHidden: function () {
          //     navigateToParent(UUID);
          // },
          titleTemplate: function titleTemplate(titleElement) {
            titleElement.append("<div class='form-title' ><span id=\"fe-title-".concat(UUID, "\">").concat(caption, "</span><div/>"));
            titleElement.find('.form-title').append(that.buttonPanel);
            return titleElement;
          }
        });
      } else {
        topBarSetDynToolBarContent(this.buttonPanel);
      }
    }
  }, {
    key: "copySSToLS",
    value: function copySSToLS() {
      var detailsData = this.state.detailsData;

      if (detailsData) {
        detailsData.forEach(function (sub) {
          if (sub.formType === System.FORM_TYPE.LIST || sub.formType === System.FORM_TYPE.TREE) {
            var lsName = createTableID(sub.formID, sub.parentFormID);
            setLSTableCols(lsName, getSSTableCols(lsName));
            setAddFilter(lsName, getAddSSFilter(lsName));
            setShowRowFilter(lsName, getShowRowSSFilter(lsName));
            sessionStorage.removeItem(lsName);
            sessionStorage.removeItem("".concat(lsName, "-filter"));
            sessionStorage.removeItem("".concat(lsName, "-row-filter"));
          }
        });
      }
    }
  }, {
    key: "createButtonPanel",
    value: function createButtonPanel() {
      if (this.props.formObj.viewMode === System.VIEW_MODE.MODAL) {
        return this.createModalButtonPanel();
      } else {
        return this.createTopBarButtonPanel();
      }
    }
  }, {
    key: "createModalButtonPanel",
    value: function createModalButtonPanel(isReadOnly) {
      if ($(this.buttonPanel).length) {
        this.changeModalButtonPanel(isReadOnly);
        return this.buttonPanel;
      }

      var buttonClasses = isReadOnly ? 'title-button disable' : 'title-button';
      var submit = $("<div class='".concat(buttonClasses, " form-submit-button' tabIndex=\"-1\">").concat(Messages.Controls.Save, "</div>"));
      var cancel = $("<div class='title-button' tabIndex=\"-1\">".concat(Messages.Controls.Cancel, "</div>"));
      !isReadOnly && submit.on('click', this._onSubmitClick.bind(this));
      cancel.on('click', this._onCancelClick.bind(this));
      return $("<div class='form-buttons-panel'/>").append(submit).append(cancel);
    }
  }, {
    key: "changeModalButtonPanel",
    value: function changeModalButtonPanel(isReadOnly) {
      var submit = $(this.buttonPanel).find('.form-submit-button');

      if (isReadOnly) {
        submit.addClass('disable').off('click');
      } else {
        submit.removeClass('disable').on('click', this._onSubmitClick.bind(this));
      }
    }
  }, {
    key: "createTopBarButtonPanel",
    value: function createTopBarButtonPanel(isReadOnly) {
      var mode = this.props.formObj.mode;
      var buttonClasses = isReadOnly ? 'title-button disable' : 'title-button';
      var buttonsProps = {
        apply: {
          className: "".concat(buttonClasses),
          tabIndex: -1,
          key: "abtb-1"
        },
        submit: {
          className: "".concat(buttonClasses),
          tabIndex: -1,
          key: "sbtb-1"
        },
        cancel: {
          className: 'title-button',
          onClick: this._onCancelClick.bind(this),
          key: "cbtb-1",
          tabIndex: -1
        }
      };

      if (!isReadOnly) {
        buttonsProps.apply.onClick = this._onApplyClick.bind(this);
        buttonsProps.submit.onClick = this._onSubmitClick.bind(this);
      }

      var apply = React.createElement('div', buttonsProps.apply, Messages.Controls.SaveWithOutClose);
      var submit = React.createElement('div', buttonsProps.submit, Messages.Controls.Save);
      var cancel = React.createElement('div', buttonsProps.cancel, Messages.Controls.Cancel);
      var buttonsList = mode === System.FORM_EDIT_CREATE_MODE.MULTI_EDIT ? [submit, cancel] : [apply, submit, cancel];
      return React.createElement('div', {
        className: 'form-buttons-panel'
      }, buttonsList);
    }
  }, {
    key: "disablingButtons",
    value: function disablingButtons(isReadOnly) {
      if (this.props.formObj.viewMode === System.VIEW_MODE.MODAL) {
        this.buttonPanel = this.createModalButtonPanel(isReadOnly);
      } else {
        topBarSetDynToolBarContent(this.createTopBarButtonPanel(isReadOnly));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.store = new FormEditStore();
      this.store.addChangeListener(this._onChange);
      window.addEventListener("beforeunload", this.copySSToLS);
      this.initForm();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.store.removeChangeListener(this._onChange);
      window.removeEventListener("beforeunload", this.copySSToLS);
      this.copySSToLS();

      if (this.popupInstance) {
        this.popupInstance.dxPopup('dispose');
        this.popupInstance.remove();
      }

      destroyForm(this.props.UUID);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.state.initialized) {
        _.each(this.state.detailsData, function (item) {
          var el = document.getElementById(item.id);
          if (el) ReactDOM.render(React.createElement(FormEditTable, {
            formID: item.formID,
            parentFormID: item.parentFormID,
            formType: item.formType,
            filtersData: item.filtersData,
            formTableMode: true,
            UUID: item.UUID,
            owner: item.owner,
            parentUUID: _this2.props.UUID,
            isFocus: item.isFocus,
            popupInst: _this2.popupInstance,
            viewSource: item.viewSource,
            requestColumns: item.requestColumns,
            tableData: item.tableData,
            masterObjKeyFieldName: item.masterObjKeyFieldName,
            detailObjKeyFieldName: item.detailObjKeyFieldName,
            viewMode: System.FORM_TYPE.EDIT,
            isReadOnly: _this2.state.isReadOnlyForm
          }), el);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var formObj = this.props.formObj;
      return React.createElement("div", {
        style: {
          height: '100%',
          padding: '16px'
        }
      }, React.createElement("div", {
        ref: function ref(r) {
          return _this3.$popupEl = $(r);
        },
        style: {
          height: '100%',
          backgroundColor: '#ffffff'
        }
      }, React.createElement("div", {
        className: "scroll-view",
        ref: function ref(r) {
          return _this3.scrollView = r;
        }
      }, React.createElement("div", {
        id: "edit-form-loader-".concat(formObj.formID)
      }), React.createElement("div", {
        id: "edit-from-".concat(formObj.formID),
        className: 'form',
        ref: function ref(r) {
          return _this3.formEl = r;
        },
        style: {
          padding: '20px'
        }
      }))));
    }
  }]);

  return FormEdit;
}(React.Component);

_defineProperty(FormEdit, "propTypes", {
  classes: PropTypes.object.isRequired,
  UUID: PropTypes.string.isRequired,
  isActive: PropTypes.bool
});

_defineProperty(FormEdit, "defaultProps", {
  formID: "".concat(Math.floor(Math.random() * 1000)),
  isActive: false
});

export default withStyles(styles)(FormEdit);